module.exports = __webpack_public_path__ + "static/img/rs_js_2.4a893bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rs/rs_js_2.png
// module id = JFoT
// module chunks = 1